// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import './setupAxios';
import './utils/api';
import checkAndroidVersion from './utils/checkAndroidVersion';
import { setCurrentUser, init } from './storage/actions/authActions';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import Footer from './components/layout/Footer';
// import './components/dashboard/css/Snehalcss.css';
// import './components/dashboard/css/Responsive.css';
// import './components/dashboard/css/Stylecommoncss.css';
import Pages from './pages';
import Spinner from './components/dashboard/common/Loader';
import { ToastHost } from './components/notification';
import 'react-toastify/dist/ReactToastify.css';
import './sass/custom_styles/dashboard-toasts.css';
import NotSupportedAndroidVersion from './pages/NotSupportedAndroidVersion';
// import './sass/custom_styles/custom_styles.scss';
// import Header from './components/Header';
import { BrowserRouter as Router } from 'react-router-dom';
import './sass/custom_styles/loader.scss';
import './sass/custom_styles/all_requested_work.scss'
class App extends React.Component {
  constructor() {     
    super();
    this.state = {
      isLowerAndroidVersion: false,
    };
  }

  componentDidMount() {
    this.props.init();
    this.setState({ isLowerAndroidVersion: checkAndroidVersion() });
  }

  render() {
    if (this.state.isLowerAndroidVersion) {
      return (<NotSupportedAndroidVersion />);
    }

    return (
      <div className="App">
        <ToastHost />
        {
          this.props.auth.init
            ? (
              <Router>
                {/* <Header /> */}
                <Pages />
              </Router>
            )
            : (
              <div className="dashboard-page-loader">
                <Spinner size="lg" className="wurqly-spiral-loader-wrap--page" />
              </div>
            )
        }
      </div>
    );
  }
}

const mapDispatchToProps = {
  setCurrentUser, init,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);